export const environment = {
  production: true,
  config: 'https://web-dev.digital.interbank.pe/bindings/js/environments/sfi-rohan-login.config.json'
};
